import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { edition } from '../edition/index.js';
import { CARD_PACKS, CLASSIC_PACK, resolvePack, type CardPackInfo } from '../lib/card-packs.js';
import { useCommunityPackStore } from './community-pack-store.js';

/**
 * The card pack: one per-device preference for every card game, like the card back. The default is the
 * classic deck, so nothing changes (and the audit goldens stay put) until a player picks a pack.
 */
interface CardPackStore {
  readonly packId: string;
  setPack(packId: string): void;
}

export const useCardPackStore = create<CardPackStore>()(
  persist(
    (set) => ({
      packId: CLASSIC_PACK,
      setPack(packId) {
        set({ packId });
      },
    }),
    { name: 's4k:card-pack' },
  ),
);

/** The active pack for this build's edition (a bundled one or a community pack added on this device), or null for the classic deck. */
export function useActivePack(): CardPackInfo | null {
  const packId = useCardPackStore((s) => s.packId);
  const community = useCommunityPackStore((s) => s.packs);
  return resolvePack(packId, edition.id, [...CARD_PACKS, ...community]);
}
